import { all, fork } from 'redux-saga/effects';
import { sagas } from '@wix/da-shared-react/pkg/redux/shared';
import biLogger from '../sagas/biLogger';
import { contactUsSaga } from './contactUs/saga';
import { oneTimePasswordSaga } from './oneTimePassword/saga';
import emailUnsubscribe from '../sagas/emailUnsubscribe';
import { featuresSaga } from './features/saga';

export default function* rootSaga() {
  yield all([
    // project
    fork(biLogger),
    fork(contactUsSaga),
    fork(oneTimePasswordSaga),
    fork(emailUnsubscribe),
    fork(featuresSaga),
    // shared
    ...sagas.map(fork),
  ]);
}
